import React from "react";
import PlantelCard from "./PlantelCard";

function PlantelesList({ planteles = [] }) {
    if (!planteles.length) {
        return (
            <div className="rounded-xl border border-white/10 bg-white/5 backdrop-blur-xl p-6 sm:p-8 text-center text-slate-400 text-sm sm:text-base">
                No se encontraron planteles para esa búsqueda.
            </div>
        );
    }

    return (
        <section className="space-y-3 sm:space-y-4">
            {planteles.map((plantel, index) => (
                <PlantelCard
                    key={`${plantel?.torneo || "plantel"}-${index}`}
                    plantel={plantel}
                />
            ))}
        </section>
    );
}

export default PlantelesList;
